// =====================================================
// LEYENDA DE LOS LOTES (BDSJEA-463): dos ejes
//  - color = destino del lote (catálogo de uso, mismo origen que el combo de destino)
//  - trama = tenencia (propio punteado, arrendado rayado, sin dato sin trama)
// Muestras generadas con la misma paleta que el mapa (constants/usosLote).
// =====================================================

import React from "react"

import {
  COLOR_USO_DEFAULT,
  LEYENDA_POLIGONO_APROXIMADO,
  PATRON_RAYADO,
  colorUso,
} from "constants/usosLote"
import { MuestraLote, MUESTRAS_TENENCIA } from "./PatronesLote"

const LeyendaLotes = ({
  usos = [],
  errorUsos = null,
  // BDSJEA-471: se muestra solo si el establecimiento tiene algún polígono aproximado
  hayAproximados = false,
}) => (
  <div className="mt-4" data-testid="leyenda-lotes">
    <h6 className="mb-2">Leyenda</h6>
    {errorUsos && (
      <div className="text-danger small mb-1">
        No se pudieron cargar los destinos: {errorUsos}
      </div>
    )}
    <div className="small">
      <div className="text-muted mb-1">Color: destino del lote</div>
      {usos.map(uso => (
        <div
          key={uso.value}
          className="d-flex align-items-center mb-1"
          data-testid="leyenda-destino"
        >
          <span style={{ marginRight: 8, display: "inline-flex" }}>
            <MuestraLote
              color={colorUso(uso.value)}
              patron={null}
              titulo={uso.label}
            />
          </span>
          <span>{uso.label}</span>
        </div>
      ))}
      <div className="text-muted mt-2 mb-1">Trama: tenencia</div>
      {MUESTRAS_TENENCIA.map(t => (
        <div
          key={t.codigo}
          className="d-flex align-items-center mb-1"
          data-testid="leyenda-tenencia"
        >
          <span style={{ marginRight: 8, display: "inline-flex" }}>
            <MuestraLote
              color={COLOR_USO_DEFAULT}
              patron={t.patron}
              titulo={`${t.etiqueta} (${t.patron})`}
            />
          </span>
          <span>
            {t.etiqueta} ({t.patron})
          </span>
        </div>
      ))}
      <div className="d-flex align-items-center mb-1">
        <span style={{ marginRight: 8, display: "inline-flex" }}>
          <MuestraLote
            color={COLOR_USO_DEFAULT}
            patron={null}
            titulo="Sin dato (sin trama)"
          />
        </span>
        <span>Sin dato (sin trama)</span>
      </div>
      {hayAproximados && (
        <div
          className="d-flex align-items-center mt-2 mb-1"
          data-testid="leyenda-aproximado"
        >
          <span style={{ marginRight: 8, display: "inline-flex" }}>
            {/* color de destino + trama (no gris liso: no se confunde con el lote por defecto) */}
            <MuestraLote
              color={colorUso("GANADERIA")}
              patron={PATRON_RAYADO}
              aproximado
              titulo={LEYENDA_POLIGONO_APROXIMADO}
            />
          </span>
          <span>
            {LEYENDA_POLIGONO_APROXIMADO}
            <small className="text-muted d-block">
              Borde punteado; color y trama según destino y tenencia
            </small>
          </span>
        </div>
      )}
    </div>
  </div>
)

export default LeyendaLotes
